export default __webpack_public_path__ + "static/media/PEBRegisterForm.229485ec.doc";